module.exports = __webpack_public_path__ + "img/icon1.b36df8b0.png";